import {
    SET_SELECTED_STORE,
    REQUIRE_SELECTED_STORE,
    SET_NEAREST_STORE,
    REQUIRE_NEAREST_STORE,
    BROWSER_GEO_PENDING,
    BROWSER_GEO_FOUND,
    FETCHING_SELECTED_STORE,
    UPDATE_SELECTED_STORE,
    RESET_SELECTED_STORE,
    ADD_CREATED_AT_TIME,
    FORCE_MANUAL_STORE_SELECTION
} from './mutations';

// Distance in miles before we force the store locator prompt
const DISTANCE_LIMIT_IN_MILES = 50;

const getGeoLocation = ( { commit, dispatch, getters } ) => {
    if (navigator.geolocation) {
        const geoOptions = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        const onSuccess = (position) => {
            const latLong = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
            };

            if (getters['nearestStoreReq/fetchNeeded']) {
                commit(BROWSER_GEO_FOUND);
                dispatch('nearestStoreReq/fetch', latLong);
            }
        };

        const onError = (error) => {
            if (getters['nearestStoreReq/fetchNeeded']) {
                commit( BROWSER_GEO_FOUND );
                dispatch('nearestStoreReq/fetch');
            }
        };

        commit(BROWSER_GEO_PENDING);

        navigator.geolocation.getCurrentPosition(onSuccess, onError, geoOptions);
    } else {
        if (getters['nearestStoreReq/fetchNeeded']) {
            dispatch( 'nearestStoreReq/fetch' );
        }
    }
};

export const actions = {
    onUpdate: function ( { state, commit, dispatch, getters } ) {
        const update = ( mutation, payload ) => {
            commit( mutation, payload );
            dispatch( 'onUpdate' );
        };

        if ( state.selectedStorePending == true )
        {
            if ( state.newLocationID != '' && state.fetchingSelectedStore == false )
            {
                commit( FETCHING_SELECTED_STORE );
                // get the new location by the id
                dispatch( 'locationReq/fetch', { location_id: state.newLocationID } );
            }

            if ( state.fetchingSelectedStore == true )
            {
                // If we have our results back from fetching a new store
                if ( getters['locationReq/results'] )
                {
                    let newStore = getters['locationReq/results'];

					if ( !newStore.success || newStore.success == 'false' ) {
                    	commit( RESET_SELECTED_STORE );
					} else {
                    	commit( SET_SELECTED_STORE, newStore );
					}

					dispatch( 'onUpdate' );
                }
            }
        }

        // If selected store is required but not yet set...
        if ( ( state.selectedStoreRequired && ( !state.selectedStore || state.selectedStoreID === null ) ) )
        {
            if ( !state.nearestStoreRequired )
            {
                commit( REQUIRE_NEAREST_STORE );
                dispatch( 'onUpdate' );
            }

            // Select nearest store if available
            if ( state.nearestStore ) {
                if (state.nearestStore.distance > DISTANCE_LIMIT_IN_MILES) {
                    commit(FORCE_MANUAL_STORE_SELECTION);
                } else {
                    update( SET_SELECTED_STORE, state.nearestStore );
                }
            }
        }

        // If we need the closest store, and we don't have one, and we're not waiting on one
        if ( state.nearestStoreRequired && !state.nearestStore && !state.browserGeoPending )
        {
            if (window.location.pathname.includes('/store/') === false) {
                getGeoLocation({ commit, dispatch, getters });
            }
        }

        // If the fetch results are different from the current state, update the current state
        if ( state.nearestStore !== getters.nearestStoreResults )
        {
            update( SET_NEAREST_STORE, getters.nearestStoreResults );
        }
    },

    requireSelectedStore: function ( { state, commit, dispatch } ) {
        if ( !state.selectedStore ||
            !state.selectedStoreRequired ||
            !state.selectedStoreID ||
            state.selectedStore == null
        )
        {
            if ( state.selectedStore && !state.selectedStoreID && state.selectedStore.location_id ) { // old ones!
                state.newLocationID = state.selectedStore.location_id;
                state.selectedStoreID = state.selectedStore.location_id;
            }

            commit( REQUIRE_SELECTED_STORE );
            dispatch( 'onUpdate' );
        }
        else
        {
            if ( state.selectedStore && state.selectedStoreID && ( //&& !state.selectedStorePending && (
                !state.selectedStore.txtLocationName ||
                !state.selectedStore.slugLocation ||
                !state.selectedStore.txtPartnerName ||
                !state.selectedStore.slugPartner ||
                !state.selectedStore.weekly_hours
            ) )
            {
                if ( !state.selectedStoreID && state.selectedStore.location_id ) { // old ones!
                    state.newLocationID = state.selectedStore.location_id;
                    state.selectedStoreID = state.selectedStore.location_id;
                }

                state.newLocationID = state.selectedStoreID;
                commit( REQUIRE_SELECTED_STORE );
                dispatch( 'onUpdate' );
            }
        }
    },

    updateSelectedStore: function ( { state, commit, dispatch }, newLocationID ) {
        if ( !newLocationID || newLocationID == undefined )
        {
            commit( RESET_SELECTED_STORE );
            // commit(REQUIRE_SELECTED_STORE);
            dispatch( 'onUpdate' );
        }

        if ( state.selectedStore == null || state.selectedStore.ControlNbr !== newLocationID )
        {
            commit( UPDATE_SELECTED_STORE, newLocationID );
            dispatch( 'onUpdate' );
        }
    },

    checkStoreTimeOut: function ( { state, commit, dispatch } ) {
        // If we have a selected store, but no refresh time
        if (state.selectedStore) {
            var ONE_HOUR = 60 * 60 * 1000;

            // If we don't have a createdAt property
            if (!state.createdAt || state.createdAt == null) {
                // Make one for the current time
                //state.createdAt = Date.now();
                commit(ADD_CREATED_AT_TIME);
                dispatch('onUpdate');
            // If the createdAt property is over an hour old
            } else if (Date.now() - state.createdAt > ONE_HOUR) {
                if (state.selectedStore.ControlNbr) {
                    if (state.selectedStore.ControlNbr != '' || state.selectedStore.ControlNbr != null) {
                        commit(UPDATE_SELECTED_STORE, state.selectedStore.ControlNbr);
                    }
                } else if (state.selectedStoreID) {
                    if (state.selectedStoreID != '' || state.selectedStoreID != null) {
                        commit(UPDATE_SELECTED_STORE, state.selectedStoreID);
                    }
                } else {
                    commit(REQUIRE_SELECTED_STORE);
                }

                dispatch('onUpdate');
            }
        }
    },
};
